export interface SubmitToSandboxSettingsFormWebComponentSchema {
  // all the data needed for rendering
}

export const MAXIMUM_ALLOWED_COMMAND_LINES_COUNT = 10;
export const MAXIMUM_COMMAND_LINE_LENGTH = 4096;
